import { TokenObject } from './token-object.model';

export interface RequireMfa {
  requireMfa: true;
  userId: string;
  mfaMethod: string;
  availableMethods?: string[];
  maskedPhone?: string;
}

export interface RequireMfaSetup {
  requireMfaSetup: true;
  userId: string;
  maskedEmail: string;
  hasSmsOption: boolean;
}

export interface RequirePasswordChange {
  requirePasswordChange: true;
  userId: string;
}

export type LoginResponse = TokenObject | RequireMfa | RequireMfaSetup | RequirePasswordChange;

export const isTokenObject = (v: LoginResponse): v is TokenObject => 'accessToken' in v;
export const isRequireMfa = (v: LoginResponse): v is RequireMfa => 'requireMfa' in v;
export const isRequireMfaSetup = (v: LoginResponse): v is RequireMfaSetup => 'requireMfaSetup' in v;
export const isRequirePasswordChange = (v: LoginResponse): v is RequirePasswordChange =>
  'requirePasswordChange' in v;
